module.exports = __webpack_public_path__ + "static/media/MX.ecac9e4c.jpeg";